import TriggerHandlerBase from '../trigger-handler-base';
import { isMatchingUrls } from '../../../../utils';

export default class ClickTriggerHandler extends TriggerHandlerBase {
  constructor(ctx, nodeService) {
    super(ctx, nodeService, 'buttonIdentifier');
    this.#setup();
    this.isInitiated = true;
  }

  /**
   * Checking if the target is a child of the buttonIdentifier
   * For the cases where a span, i or similar element is placed within a button and the user clicks on that element
   * @param {Node} target Event.target
   * @param {*} identifier buttonIdentifier from the trigger object
   * @returns {Boolean}
   */
  static targetMatches(target, identifier) {
    let node = target;

    while (node && !node.matches(identifier)) {
      node = node.parentNode;
    }

    return node;
  }

  #setup() {
    document.addEventListener('click', this.#clickHandler.bind(this));
  }

  #clickHandler(event) {
    const { target } = event;
    const route = this.store.getters['pageLoadTriggerStore/currentRoute'];
    const trigger = this.getTriggers().find((tgr) => {
      try {
        return isMatchingUrls(route, tgr) && ClickTriggerHandler.targetMatches(target, tgr.buttonIdentifier);
      } catch (error) {
        return false;
      }
    });

    if (trigger) {
      this.startConversation(trigger);
    }
  }
}
